//imports
import {
    UNSUBSCRIBED_CONTACT_DELETE_OPEN_MODAL,
    UNSUBSCRIBED_CONTACT_DELETE_CLOSE_MODAL,
    UNSUBSCRIBED_CONTACT_DELETE_REQUEST,
    UNSUBSCRIBED_CONTACT_DELETE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    deleteUnsubscribedContact: null,
    openModal: false,
    unsubscribedContacts: []
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case UNSUBSCRIBED_CONTACT_DELETE_REQUEST:
            return { ...state, loading: true }

        case UNSUBSCRIBED_CONTACT_DELETE_RESULT:
            return { ...state, loading: false, deleteUnsubscribedContact: action.payload }

        case UNSUBSCRIBED_CONTACT_DELETE_OPEN_MODAL:
            return { ...state, openModal: true, unsubscribedContacts: action.payload }

        case UNSUBSCRIBED_CONTACT_DELETE_CLOSE_MODAL:
            return { ...state, openModal: false }

        case CLEAR_REDUX:
            return ["", "UNSUBSCRIBED_CONTACT_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
